import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "../../../styles/pages/dashboard/adminDashboardPageComponent.scss";

// M3: agent workspace. Focused on placing orders on behalf of customers (no catalog/settings/users
// management). The first real consumer of the AgentRoute guard.
export const AgentDashboardPageComponent = () => {
  const selectedCustomer = useSelector((state) => state.agentOrderReducer.selectedCustomer);
  // M6: gate the add-customer entry on the agent's CanAddCustomers (surfaced via UserInfo).
  // This is UI gating only — the server enforces the permission in RegisterBusiness regardless.
  const userInfo = useSelector((state) => state.accountReducer.userInfo);

  const dashboardItems = [
    {
      title: "סקירת הלקוחות שלי",
      link: "analytics",
      description: "מכירות ולקוחות לא פעילים",
      icon: "fa-solid fa-chart-pie",
    },
    {
      title: "הזמנה חדשה ללקוח",
      link: "?d=customer&action=select",
      description: "בחירת לקוח וביצוע הזמנה בשמו",
      icon: "fa-solid fa-cart-plus",
    },
    {
      // M4: order history scoped server-side to the agent's assigned customers.
      title: "היסטוריית הזמנות",
      link: "orders",
      description: "צפייה בהזמנות של הלקוחות המשויכים אליך",
      icon: "fa-solid fa-clock-rotate-left",
    },
    // M6: shown only to agents permitted to add customers. Opens the shared add dialog (the dialog
    // fetches the agent's assignment-scoped customer list).
    ...(userInfo?.canAddCustomers
      ? [
          {
            title: "הוספת לקוח",
            link: "?d=account&action=add",
            description: "פתיחת חשבון התחברות ללקוח קיים",
            icon: "fa-solid fa-user-plus",
          },
        ]
      : []),
  ];

  return (
    <div className="adminDashboardContainer">
      <div className="adminDashboardHeader">
        <h1 className="adminDashboardTitle">איזור הסוכן</h1>
        <p className="adminDashboardSubtitle">בחר את הפעולה שברצונך לבצע</p>
        {selectedCustomer && (
          <div className="selectedCustomerBadge">
            <i className="fa-solid fa-user-check"></i>
            <span>
              {selectedCustomer.firstName} {selectedCustomer.lastName} (קוד {selectedCustomer.customerId})
            </span>
          </div>
        )}
      </div>

      <div className="adminDashboardGrid adminDashboardGrid--twoCol">
        {dashboardItems.map((item, index) => (
          <Link key={index} to={item.link} className="adminDashboardCard">
            <div className="adminDashboardCardIcon">
              <i className={item.icon}></i>
            </div>
            <div className="adminDashboardCardContent">
              <h3 className="adminDashboardCardTitle">{item.title}</h3>
              <p className="adminDashboardCardDescription">{item.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AgentDashboardPageComponent;
